import { mediaQueries } from './media-queries';

let lazyVideos;

function initLazyVideoObserver() {
    const margins = `${window.innerHeight * 0.75}px 0px 0px 0px`;

    if ("IntersectionObserver" in window) {
        const lazyVideoObserver = new IntersectionObserver(intersectionHandler, { rootMargin: margins});
    
        lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
}

function intersectionHandler(entries, observer) {
    entries.forEach(function(video) {
        if (video.isIntersecting) {
            for (let source in video.target.children) {
                const videoSource = video.target.children[source];

                if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                    if (videoSource.dataset.mediaQuery && mediaQueries[videoSource.dataset.mediaQuery].matches) {
                        videoSource.src = videoSource.dataset.src;
                    }
                    
                    if (!videoSource.dataset.mediaQuery) {
                        videoSource.src = videoSource.dataset.src;
                    }
                }
            }

            video.target.load();
            video.target.classList.add("lazy-loaded");
            observer.unobserve(video.target);
        }
    });
}

const initLazyLoader = () => {
    lazyVideos = [...document.querySelectorAll('video[data-lazy]')];

    if (lazyVideos.length > 0) {
        initLazyVideoObserver();
    }
}

export default initLazyLoader;
